const SMSIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8334 5.83325H5.00002M15.8334 9.16659H8.33335M15.8334 0.833252H4.16669C2.32574 0.833252 0.833355 2.32564 0.833355 4.16659V10.8333C0.833355 12.6742 2.32574 14.1666 4.16669 14.1666H14.1667L19.1667 18.3333V4.16659C19.1667 2.32564 17.6743 0.833252 15.8334 0.833252Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SMSIcon;
